import { AdminPanelSettingsOutlined } from '@mui/icons-material'
import { useMutationAdminPanelHandoff } from '../../../queries/userQueries'
import { ADMIN_PANEL_URL } from '../../utils/constant'

const openAdminPanel = async (adminWindow, requestEntryUrl) => {
  try {
    adminWindow.location.href = await requestEntryUrl()
  } catch {
    if (ADMIN_PANEL_URL) {
      adminWindow.location.href = ADMIN_PANEL_URL
      return
    }
    adminWindow.close()
  }
}

export const AdminPanelSidebarButton = ({ isExpandedView }) => {
  const handoffMutation = useMutationAdminPanelHandoff()

  const handleClick = () => {
    const adminWindow = window.open('', '_blank')
    if (!adminWindow) return
    adminWindow.opener = null
    openAdminPanel(adminWindow, handoffMutation.mutateAsync)
  }

  return (
    <button
      type='button'
      onClick={handleClick}
      disabled={handoffMutation.isPending}
      title='Ir al panel'
      className={`
        flex items-center gap-4 mb-4 py-1 px-3 rounded-full text-white transition-all relative
        hover:bg-white/35 hover:scale-110 active:scale-100 disabled:opacity-60
        ${!isExpandedView ? 'p-4 w-12 h-12' : 'px-4 py-2'}
      `}
    >
      <div className='flex justify-center items-center w-10 h-10 rounded-full'>
        <AdminPanelSettingsOutlined style={{ fontSize: '1.5rem', width: '1.5rem', height: '1.5rem' }} />
      </div>
      {isExpandedView && (
        <p className='text-[13px] md:text-sm font-semibold'>Ir al panel</p>
      )}
    </button>
  )
}
